export default __webpack_public_path__ + "static/media/021-Rocket Raccoon.073f45de.svg";